import React from 'react';
import { Link } from 'react-router-dom';


import BlackSymbolLogo from 'assets/images/logo/symbol_black.png';
import WhiteSymbolLogo from 'assets/images/logo/symbol_white.png';
import styled from 'styled-components';

import { clickToGTM } from 'utils/seo/seoGTMUtil';

const Logo = ({
  isMobile,
  isToggleMenu,
  onHandleSlideReset,
  setIsToggleMenu,
  linkTo = '/',
}) => {
  return (
    <LogoWrapper
      $isMobile={isMobile}
      className="logo"
      onClick={() => {
        // GTM 이벤트 전송
        clickToGTM({
          target: 'INAVI Maps 로고',
          id: `header-inavi-maps-logo`,
          url: window.location.host + '/',
        });
        if (onHandleSlideReset) onHandleSlideReset();
        if (setIsToggleMenu) setIsToggleMenu(false);
      }}
    >
      <Link to={linkTo}>
        {isToggleMenu ? (
          <img src={BlackSymbolLogo} alt="inavi" />
        ) : (
          <img src={WhiteSymbolLogo} alt="inavi" />
        )}
      </Link>
    </LogoWrapper>
  );
};

export default Logo;

const LogoWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-right: ${({ $isMobile }) => ($isMobile ? '0' : '32px')};

  img {
    display: flex;
    justify-content: center;
    align-items: center;
    object-fit: contain;
    ${({ $isMobile }) => ($isMobile ? `width: 140px;` : `width: 145px;`)}
  }
`;
